import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Lock, Eye, EyeOff } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/menu`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("menu-admin-token", data.token);
      navigate("/menu/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Errore di connessione");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="menu-admin-login" className="flex min-h-[70vh] items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <Link to="/menu" data-testid="menu-admin-back" className="mb-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#A3A3A3] transition-colors hover:text-[#E5CAA4]">
          ← Torna al menu
        </Link>
        <form onSubmit={submit} className="rounded-lg border border-[#C19D60]/20 bg-[#101012] p-9">
        <Lock size={22} strokeWidth={1.2} className="text-[#C19D60]" />
        <h1 className="font-display mt-4 text-3xl font-semibold">Area riservata</h1>
        <p className="mt-2 text-sm font-light text-[#A3A3A3]">Gestione menu — accesso amministratore.</p>
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          data-testid="menu-admin-email" placeholder="Email"
          className="mt-8 w-full border-b border-[#C19D60]/30 bg-transparent py-3 text-sm outline-none placeholder:text-[#666] focus:border-[#C19D60]"
        />
        <div className="relative mt-5">
          <input
            type={showPw ? "text" : "password"} required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="menu-admin-password" placeholder="Password"
            className="w-full border-b border-[#C19D60]/30 bg-transparent py-3 pr-10 text-sm outline-none placeholder:text-[#666] focus:border-[#C19D60]"
          />
          <button
            type="button" onClick={() => setShowPw(!showPw)}
            data-testid="menu-admin-toggle-password" aria-label="Mostra password"
            className="absolute right-0 top-1/2 -translate-y-1/2 p-1.5 text-[#A3A3A3] transition-colors hover:text-[#E5CAA4]"
          >
            {showPw ? <EyeOff size={17} strokeWidth={1.4} /> : <Eye size={17} strokeWidth={1.4} />}
          </button>
        </div>
        {error && <p data-testid="menu-admin-error" className="mt-4 text-sm text-red-400">{error}</p>}
        <button
          type="submit" disabled={loading} data-testid="menu-admin-submit"
          className="mt-8 w-full rounded-[5px] bg-[#C19D60] py-3.5 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#0a0a0b] transition-colors hover:bg-[#E5CAA4] disabled:opacity-50"
        >
          {loading ? "…" : "Accedi"}
        </button>
        </form>
      </div>
    </div>
  );
}
